import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "device-measurments-view" }

import { ref, onMounted, computed } from 'vue'
import { useDeviceMeasurementsStore } from './store'
import { DeviceMeasurements } from './models/deviceMeasurements'


export default /*@__PURE__*/_defineComponent({
  __name: 'DeviceMeasurementsView',
  setup(__props) {

const deviceMeasurementsStore = useDeviceMeasurementsStore()
const loading = ref(false)

const headers = [
  { title: 'ID', key: 'id' },
  { title: 'Tiempo', key: 'time' },
  { title: 'Dispositivo ID', key: 'deviceId' },
  { title: 'Sensor ID', key: 'sensorId' },
  { title: 'Validado', key: 'validated' },
  { title: 'Valor', key: 'value' },
  { title: 'Texto Valor', key: 'valueText' },
  { title: 'Acciones', key: 'actions', sortable: false },
]

const deviceMeasurementsList = computed(() => deviceMeasurementsStore.deviceMeasurements)

const formatDate = (date: Date | string) => {
  return new Date(date).toLocaleString('es-ES')
}

const refreshData = async () => {
  loading.value = true
  try {
    await deviceMeasurementsStore.getDeviceMeasurements()
  } finally {
    loading.value = false
  }
}

const editItem = (item: DeviceMeasurements) => {
  // Implementar lógica de edición
  console.log('Edit item:', item)
}

const deleteItem = (item: DeviceMeasurements) => {
  // Implementar lógica de eliminación
  console.log('Delete item:', item)
}

onMounted(() => {
  refreshData()
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("h1", null, "Device Data", -1),
                _createElementVNode("p", null, "Gestión de datos de dispositivos", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: headers,
                  items: deviceMeasurementsList.value,
                  loading: loading.value,
                  class: "elevation-1"
                }, {
                  top: _withCtx(() => [
                    _createVNode(_component_v_toolbar, { flat: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_toolbar_title, null, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode("Lista de Datos de Dispositivos")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_divider, {
                          class: "mx-4",
                          inset: "",
                          vertical: ""
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          onClick: refreshData
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode("mdi-refresh")
                              ])),
                              _: 1
                            }),
                            _cache[3] || (_cache[3] = _createTextVNode(" Actualizar "))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  "item.time": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(formatDate(item.time)), 1)
                  ]),
                  "item.validated": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: item.validated ? 'success' : 'error',
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.validated ? 'Validado' : 'No validado'), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.actions": _withCtx(({ item }) => [
                    _createVNode(_component_v_icon, {
                      small: "",
                      class: "mr-2",
                      onClick: ($event: any) => (editItem(item))
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode(" mdi-pencil ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_v_icon, {
                      small: "",
                      onClick: ($event: any) => (deleteItem(item))
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode(" mdi-delete ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["items", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})